import {memo} from 'react'
import {Spinner} from '@/shared/ui'

export const RoomLoadingState = memo(function RoomLoadingState() {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-6 text-foreground">
      <Spinner size="large" />
      <p className="text-xl font-medium opacity-90">Подключение…</p>
    </div>
  )
})
